// Sterling-asset-fix
// -------------------
// The @silverfalls/sterling package defines --opco-logo-h URLs in both its
// tokens.css and components.css using a relative path
// (`../../assets/sportworks-black.png`) that resolves to a directory that
// doesn't exist outside the package's dist/. Vite rewrites ONE of the two
// occurrences when bundling, but the other shadows it — so the OpcoLogo
// component ends up trying to load a broken URL on most OpCos (most
// visibly Sportworks: gold logo on gold background = invisible).
//
// Fix: import each asset explicitly so Vite resolves it through the
// package's `./assets/*` export, then write the resolved URLs onto the
// matching `[data-opco]` blocks at runtime. One write at app boot;
// per-OpCo switching keeps using the values written here because Sterling
// reads `--opco-logo-h` from the cascade.

import silverFallsLogoH from '@silverfalls/sterling/assets/silver-falls-stacked-white.png';
import silverFallsLogoHOnLight from '@silverfalls/sterling/assets/silver-falls-stacked-fc.png';
import sportworksLogoH from '@silverfalls/sterling/assets/sportworks-black.png';
import omniLogoH from '@silverfalls/sterling/assets/omni-cleanair-white.png';
import omniLogoHOnLight from '@silverfalls/sterling/assets/omni-cleanair-fc.png';
import birdbufferLogoH from '@silverfalls/sterling/assets/birdbuffer.png';
import citcLogoH from '@silverfalls/sterling/assets/citc-white.png';
import citcLogoHOnLight from '@silverfalls/sterling/assets/citc-black.jpg';

interface OpcoLogoOverride {
  readonly id: string;
  readonly logoH: string;
  readonly logoHOnLight: string;
}

const OVERRIDES: ReadonlyArray<OpcoLogoOverride> = [
  { id: 'silver-falls', logoH: silverFallsLogoH,  logoHOnLight: silverFallsLogoHOnLight },
  { id: 'sportworks',   logoH: sportworksLogoH,   logoHOnLight: sportworksLogoH }, // yellow bar → black logo, same image
  { id: 'omni',         logoH: omniLogoH,         logoHOnLight: omniLogoHOnLight },
  { id: 'birdbuffer',   logoH: birdbufferLogoH,   logoHOnLight: birdbufferLogoH },
  { id: 'citc',         logoH: citcLogoH,         logoHOnLight: citcLogoHOnLight },
];

export function applySterlingAssetFix(): void {
  // Inject a single <style> with the resolved URLs. Loading this AFTER
  // Sterling's tokens.css + components.css means our rules win the
  // cascade. Asset URLs are content-hashed by Vite; the resulting URLs
  // look like `/assets/sportworks-black-Bu4c_juz.png`.
  const rules = OVERRIDES.map(
    (o) =>
      `[data-opco="${o.id}"] { ` +
      `--opco-logo-h: url('${o.logoH}'); ` +
      `--opco-logo-h-on-light: url('${o.logoHOnLight}'); ` +
      `}`,
  ).join('\n');
  const style = document.createElement('style');
  style.dataset['sterlingAssetFix'] = 'v1';
  style.textContent = rules;
  document.head.appendChild(style);
}
